module.exports = __webpack_public_path__ + "static/media/he.a1b3cba7.svg";